export default {"src":"/_next/static/media/about-us-icon.c535485f.svg","height":81,"width":164,"blurWidth":0,"blurHeight":0};